import { type Scope, createContextScope } from '@radix-ui/react-context'
import type { ButtonHTMLAttributes } from 'react'
import { ContentActions } from './components/content-actions'
import { ContentActionsText } from './components/content-actions-text'
import { ContentIcon } from './components/content-icon'
import { ContentLink } from './components/content-link'
import { ContentSubtitle } from './components/content-subtitle'
import { ContentTitle } from './components/content-title'
import { ContentRootVariants } from './content.styles'
import type {
  ContentContext,
  ContentProps,
  ContentScopedProps,
} from './content.types'

export const DISPLAY_NAME = 'Content'

type ContentRootProps = ContentProps & ButtonHTMLAttributes<HTMLButtonElement>

function ContentRoot(props: ContentRootProps) {
  const { children, variants, size, __scopeContent } =
    props as ContentScopedProps<ContentRootProps>
  const contentProviderProps = {
    scope: __scopeContent,
    variants,
    size,
  }

  return (
    <ContentProvider {...contentProviderProps}>
      <button
        disabled={variants === 'title'}
        type="button"
        className={ContentRootVariants({ variants })}
        data-testid="content-root"
      >
        {children}
      </button>
    </ContentProvider>
  )
}

const [createContentContext] = createContextScope(DISPLAY_NAME)

export const [ContentProvider, useContentContext]: readonly [
  ProviderType<ContentContext>,
  (consumerName: string, scope: Scope) => ContentContext,
] = createContentContext<ContentContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Content = {
  Root: ContentRoot,
  Icon: ContentIcon,
  ActionsText: ContentActionsText,
  Title: ContentTitle,
  Subtitle: ContentSubtitle,
  Actions: ContentActions,
  Link: ContentLink,
}
